import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';
import './less/main.less';
import { rem, log } from 'base-libs';
import Index from './pages/Index.vue';
import Tnc from './pages/Tnc.vue';
import Guide from './pages/Guide.vue';

log.init();

Vue.config.errorHandler = function (err) {
    log.error(err);
    console.error(err);
};
rem();
Vue.config.productionTip = false;
Vue.use(VueRouter);

//定义路由
const routes = [
    { name: 'index', path: '/', component: Index },
    { name: 'tnc', path: '/tnc', component: Tnc },
    { name: 'guide', path: '/guide', component: Guide }
];

// 3. 创建 router 实例，然后传 `routes` 配置
const router = new VueRouter({
    routes // (缩写) 相当于 routes: routes
});

// 4. 创建和挂载根实例。
// 记得要通过 router 配置参数注入路由，
// 从而让整个应用都有路由功能

new Vue({
    router,
    render: h => h(App, {
        props: {}
    }),
    created() {
    }
}).$mount('#app');

